import React, { useEffect, useRef, useState } from 'react';
import ScenePlayer from './ScenePlayer';
import apiClient from '../services/apiClient';
import { getLanguage, t } from '../i18n';

const INITIAL_MANUAL_SCENE_ID = 'init_manual';

function InitialManualScene({ onContinue }) {
  const language = getLanguage();
  const [scene, setScene] = useState(null);
  const onContinueRef = useRef(onContinue);

  useEffect(() => {
    onContinueRef.current = onContinue;
  }, [onContinue]);

  useEffect(() => {
    let cancelled = false;

    apiClient.getSceneById(INITIAL_MANUAL_SCENE_ID)
      .then((result) => {
        if (cancelled) return;
        if (result?.scene) {
          setScene(result.scene);
          return;
        }
        onContinueRef.current?.();
      })
      .catch((error) => {
        console.warn('Failed to load the initial manual scene:', error);
        if (!cancelled) onContinueRef.current?.();
      });

    return () => {
      cancelled = true;
    };
  }, [language]);

  if (!scene) return null;

  return (
    <ScenePlayer
      scene={scene}
      onContinue={onContinue}
      variant="coaching"
      nextLabel={t('common.next', language)}
      continueLabel={t('common.startTraining', language)}
      messageTestId="initial-manual-scene-message"
    />
  );
}

export { INITIAL_MANUAL_SCENE_ID };
export default InitialManualScene;
